/*
 * @Author: your name
 * @Date: 2020-01-16 13:43:59
 * @LastEditTime : 2020-02-18 10:50:57
 * @LastEditors  : Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /fx-operate-admin/src/stores/finance/settlementAudit.js
 */
import { observable, action } from "mobx";
import { httpClient } from "../../utils/httpClient";
import api from "../../config/api";
const { finance } = api;

class settlementAudit {

  constructor() {
    this.updataStore = this.updataStore.bind(this);
    this.queryBill = this.queryBill.bind(this);
    this.queryLatestTen = this.queryLatestTen.bind(this);
    this.queryDetailByBalanceId = this.queryDetailByBalanceId.bind(this);
    this.queryAssociatedOrderByBalanceId = this.queryAssociatedOrderByBalanceId.bind(this);
    this.queryLogisticByExpressNo = this.queryLogisticByExpressNo.bind(this);
    this.exportBalanceExcel = this.exportBalanceExcel.bind(this);
    this.queryExpressData = this.queryExpressData.bind(this);
  }
  // 供应商结算审核 > 结算详情 > 结算单dialog vis
  @observable finaltatementVisible = false;
  // 供应商结算审核 > 结算详情 > 驳回dialog vis
  @observable turnDownVisible = false;
  // 供应商结算审核 > 结算详情 > 通过dialog vis
  @observable passVisible = false;
    // 供应商结算审核 > 结算详情 > 查询物流信息dialog vis
  @observable logisticsVisible = false;
  // 供应商结算审核 > 结算详情 > 订单明细dialog vis
  @observable indentDetailVisible = false;

  @observable pageInfo = {
    pageSize: 10,
    pageNo: 1,
  };
  @observable formData = {
    applyTimeStart: null,
    applyTimeEnd: null,
    resolveTimeStart: null,
    resolveTimeEnd: null,
    auditStatus: null,
    supplierId: null,
};
  @observable total = 0;
  @observable balanceList = [];
  @observable balanceLoading = false;
  @observable balanceId = '';
  @observable queryBillData = {};
  @observable queryBillLoading = false;
  @observable latestTenList = [];
  @observable settleLoading = false;

  @observable detailPageInfo = {
    pageSize: 10,
    pageNo: 1,
  }
  @observable detailToatal = 0;
  @observable detailByBalanceList = [];
  @observable detailByBalanceLoading = false;

  // detail order
  @observable detailFlag = "detail";

  @observable associatedOrderByBalanceList = [];
  @observable associatedOrderByBalanceTotal = 0;
  @observable associatedOrderByBalancePageInfo = {
    pageSize: 10,
    pageNo: 1,
  };
  @observable associatedOrderByBalanceLoading = false;
  @observable logisticsInfo = []; // 物流信息
  @observable logisticsLoading = false;

  @observable expressData = new Map();

  @action async updataStore(key, value) {
    let type = typeof key;
    let _self = this;
    switch(type) {
      case 'object':
        Object.keys(key).forEach(item => { _self[item] = key[item];});
        break;
      default:
        _self[key] = value;
    }
  }
  @action async queryBalancePage(params) {
    try {
      this.balanceLoading = true;
      const { data: { list = [], page = 1, pageSize = 1, total = 0 } } = await httpClient.post(finance.QUERY_BALANCE_PAGE, {
        ...this.pageInfo,
        ...this.formData,
        ...params
      });
      this.balanceList = list;
      this.total = total;
      this.pageInfo = {
        pageSize,
        pageNo: page,
      }
    } catch(e) {
      this.balanceList = [];
      this.total = 0;
      this.pageInfo = {
        pageSize: 10,
        pageNo: 1,
      }
    }
    this.balanceLoading = false;
  }
  @action async queryBill(params) {
    try {
      this.queryBillLoading = true;
      const { data } = await httpClient.get(finance.QUERY_BILL, {
        params,
      });
      this.queryBillData = data;
      this.queryBillLoading = false;
    }
    catch(e) {
      this.queryBillData = {};
      this.queryBillLoading = false;
    }
  }
  // 查询结算单商品明细（开票明细）
  @action async queryDetailByBalanceId(params) {
    this.detailByBalanceLoading = true;
    try {
      const { data: { list = [], page = 1, pageSize = 10, total = 0 } } = await httpClient.post(finance.QUERY_DETAIL_BY_BALANCEID, {
        ...params,
      });
      this.detailPageInfo = {
        pageSize,
        pageNo: page,
      }
      this.detailToatal = total;
      this.detailByBalanceList = list;
    } catch(e) {
      this.detailPageInfo = {
        pageSize: 10,
        pageNo: 1,
      }
      this.detailToatal = 0;
      this.detailByBalanceList = [];
    }
    this.detailByBalanceLoading = false;
  }
  @action exportBalancePdf(params) {
    return httpClient.get(finance.EXPORT_BALANCE_PDF, { params, responseType: 'blob' });
  }
  @action async queryLatestTen(params) {
    try {
      const { data = [] } = await httpClient.get(finance.QUERY_LATEST_TEN, { params });
      this.latestTenList = data;
    } catch(e) {
      this.latestTenList = [];
    }
  }
  @action async auditBill(params) {
    return httpClient.post(finance.AUDIT_BILL, params);
  }
  // QUERY_ASS_BALANCEID
  // @action async queryAssociatedOrderByBalanceId(params) {
  //   this.associatedOrderByBalanceLoading = true;
  //   try {
  //     const { data: { list = [], page = 1, pageSize = 10, total = 0 } } = await httpClient.get(finance.QUERY_ASS_BALANCEID, { params });
  //     this.associatedOrderByBalanceList = list;
  //     this.associatedOrderByBalanceTotal = total;
  //     this.associatedOrderByBalancePageInfo = { pageSize, pageIndex: page };
  //   } catch(e) {
  //     this.associatedOrderByBalanceList = [];
  //     this.associatedOrderByBalanceTotal = 0;
  //     this.associatedOrderByBalancePageInfo = { pageSize: 10, pageIndex: 1 };
  //   }
  //   this.associatedOrderByBalanceLoading = false;
  // }

  @action async queryAssociatedOrderByBalanceId(params) {
    this.detailByBalanceLoading = true;
    this.detailPageInfo = {
      pageSize: 10,
      pageNo: 1,
    }
    this.detailToatal = 0;
    this.detailByBalanceList = [];
    try {
      const { data: { list = [], page = 1, pageSize = 10, total = 0 } } = await httpClient.post(finance.QUERY_ASS_BALANCEID, {
        ...params,
      });
      this.detailPageInfo = {
        pageSize,
        pageNo: page,
      }
      this.detailToatal = total;
      this.detailByBalanceList = list;
    } catch(e) {
      this.detailPageInfo = {
        pageSize: 10,
        pageNo: 1,
      }
      this.detailToatal = 0;
      this.detailByBalanceList = [];
    }
    this.detailByBalanceLoading = false;
  }

  @action async exportBalanceExcel(params) {
    const apiUrl = this.detailFlag === 'detail' ? finance.EXPORT_BALANCE_EXCEL : finance.EXPORT_ORDER_EXCEL;
    return httpClient.get(apiUrl, { params, responseType: 'blob' });
  }
  // 查询物流信息
  @action async queryLogisticByExpressNo(params) {
    this.logisticsLoading = true;
    try {
      const { data } = await httpClient.get(finance.GET_LOGISTICS, { params });
      if(data) {
        this.logisticsInfo = JSON.parse(data);
      }
    } catch(e) {

    }
    this.logisticsLoading = false;
  }
  @action async queryExpressData() {
    try {

      const { data } = await httpClient.get(finance.EXPRESS_LIST);
      this.expressData = new Map(data && data.map( (item) => [item.expressName,item.expressCode]));
    } catch(e) {
      this.expressData = new Map();
    }
  }
}

export default new settlementAudit();